<template>
  <v-form ref="form" v-model="formFieldsValid" lazy-validation>
    <v-container fluid>
      <v-row dense>
        <v-col md="6" lg="4" xl="3">
          <v-card>
            <v-row dense>
              <v-col><v-text-field label="Totale imponibile" hide-details outlined dense readonly :value="euro(totale.imponibile)"></v-text-field></v-col>
              <v-col><v-text-field label="Sconto" hide-details outlined dense readonly></v-text-field></v-col>
              <v-col><v-text-field label="Netto merce" hide-details outlined dense readonly :value="euro(totale.imponibile)"></v-text-field></v-col>
            </v-row>  
            <v-simple-table dense>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left">IVA</th>
                    <th class="text-right">IMPONIBILE</th>
                    <th class="text-right">IMPOSTA</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="item in dettaglioIva" :key="item.aliquota">
                    <td class="text-left">{{ item.aliquota + '%' }}</td>
                    <td class="text-right">{{ item.imponibile | euro }}</td>
                    <td class="text-right">{{ item.iva | euro }}</td>
                  </tr>
                </tbody>
                <tfoot>
                  <tr>
                    <th class="text-left">Totale</th>
                    <th class="text-right">{{ totale.imponibile | euro }}</th>
                    <th class="text-right">{{ totale.iva | euro }}</th>
                  </tr>
                </tfoot>                  
              </template>
            </v-simple-table>
          </v-card>
        </v-col>
        <v-col md="6" lg="4" xl="3">
          <v-card>
            <v-row dense>
              <v-col><v-text-field label="Modalità di pagamento" class="text-caption" hide-details outlined dense readonly :value="modalitaPagamento"></v-text-field></v-col>              
              <v-col><v-text-field label="Condizioni di pagamento" class="text-caption" hide-details outlined dense readonly :value="condizioniPagamento"></v-text-field></v-col>
            </v-row>
            <v-row dense v-if="infoBanca">
              <v-col><v-text-field label="IBAN" class="text-caption" hide-details outlined dense readonly :value="infoBanca.IBAN"></v-text-field></v-col>
              <v-col><v-text-field label="Banca" class="text-caption" hide-details outlined dense :value="infoBanca.descrizione"></v-text-field></v-col>
            </v-row>
            <v-simple-table dense class="mt-0">
              <template v-slot:default>
                <thead>
                  <tr>
                    <th>SCADENZE PAGAMENTI</th>
                  <tr>
                    <th class="text-left"></th>
                    <th class="text-right">DATA</th>
                    <th class="text-right">IMPORTO</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, index) in scadenzePagamenti" :key="item.data">
                    <td class="text-left">Rata {{index + 1}}</td>
                    <td class="text-right">{{ item.data }}</td>
                    <td class="text-right">{{ item.importo | euro }}</td>
                  </tr>
                </tbody>              
              </template>
            </v-simple-table>
          </v-card>
        </v-col>

       <v-col md="6" lg="4" xl="3">
          <v-card>
            <v-simple-table dense class="mt-0">
              <template v-slot:default>
                <thead>
                  <tr>
                    <th>RIEPILOGO SPESE</th>
                  <tr>
                    <th class="text-right">DESCRIZIONE</th>
                    <th class="text-right">IMPORTO</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="item in speseFattura" :key="item.descrizione">
                    <td class="text-right">{{ item.descrizione }}</td>
                    <td class="text-right">{{ item.importo | euro }}</td>
                  </tr>
                </tbody>
                <tfoot>
                  <tr>
                    <th class="text-right">TOTALE</th>
                    <th class="text-right">{{ totale.spese | euro }}</th>
                  </tr>
                </tfoot>            
              </template>
            </v-simple-table>
          </v-card>
        </v-col>  

        <v-col>
          <v-card>
<!--             <v-row dense>
              <v-col><v-text-field label="Spese bancarie" hide-details outlined dense></v-text-field></v-col>
              <v-col><v-text-field label="Spese trasporto" hide-details outlined dense></v-text-field></v-col>
              <v-col><v-text-field label="Spese imballaggio" hide-details outlined dense></v-text-field></v-col>
              <v-col><v-text-field label="Altre spese" hide-details outlined dense></v-text-field></v-col>
            </v-row> -->
            <v-row dense>
              <v-col>
                <v-textarea label="Annotazioni" hide-details outlined dense value=""></v-textarea>
              </v-col>
            </v-row>
            <v-row dense>
              <v-col>
                <v-simple-table dense class="mt-0">
                  <template v-slot:default>
                    <thead>
                      <tr>
                        <th class="text-right">TOTALE QUANTITA'</th>
                        <th class="text-right">TOTALE DOCUMENTO</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td class="text-right text-h5">{{ totale.quantita }}</td>
                        <td class="text-right text-h5 blue-grey lighten-4">{{ totale.importo | euro }}</td>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>
              </v-col>
            </v-row>    
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </v-form>
</template>

<script>
import * as dot from 'dot-object'
import _ from 'lodash'
import configurazioni from '@/services/configurazioniService.js'
import clienti from '@/services/clientiService.js'

/* import pTesto from '@/views/drawer/elementi/testo'
import pMultiselect from '@/views/drawer/elementi/multiselect'
import pData from '@/views/drawer/elementi/data'
import pProdotto from '@/views/drawer/elementi/prodotto'
import pClifor from '@/views/drawer/elementi/clifor'
import pDestinazioni from '@/views/drawer/elementi/destinazioni' */

export default {
  components: {
/*     pTesto,
    pMultiselect,
    pData,
    pProdotto,
    pClifor,
    pDestinazioni */
  },
  props: {
    locDocumento: Object,
    trigger: Number
  },
  data: (vm) => ({
    backoffice: null,
    show: false,
    formFieldsValid: true,
    dialogConferma: false,
    titoloConferma: '',
    messaggioConferma: '',
    onConferma: vm.modificaPrezzoAcquisto,
    updateTrigger: 1
  }),
  async mounted() {
    this.backoffice = await configurazioni.getConfigurazione('backoffice', 'pagine')
    // console.log(this.locDocumento)
  },
  computed: {
    totale() {
      if (this.locDocumento) {
        const totale = this.locDocumento.totali
        return totale.generale
      } else {
        return {}
      }
    },
    dettaglioIva() {
      if (this.locDocumento) {
        const totali = _.omit(this.locDocumento.totali, 'generale')   
        const ive = Object.values(totali)
        return ive
      } else {
        return {}
      }
    },
    scadenzePagamenti() {
      if (this.locDocumento) {
        return this.locDocumento.scadenze
      } else {
        return []
      }
    },
    speseFattura() {
      if (this.locDocumento) {
        return this.locDocumento.spese
      } else {
        return []
      }
    },
    pagamento() {
     if (this.locDocumento) {
        return this.locDocumento.pagamento
      } else {
        return {}
      }
    },
    modalitaPagamento() {
      return this.pagamento ? _.get(this.pagamento, 'modalita.descrizione', '') : ''
    },
    condizioniPagamento() {
      return this.pagamento ? _.get(this.pagamento, 'condizioni.descrizione', '') : ''
    },
    infoBanca() {
     if (this.pagamento) {
        return this.pagamento.infoBanca
       console.log(this.pagamento.infoBanca)
      } else {
        return {}
      }
/*      if (this.locDocumento && this.locDocumento.infoBanca) {
       console.log(this.locDocumento.infoBanca)
        return this.locDocumento.infoBanca
      } else {
        return {}
      } */
    }
/*     documentoItems() {
      if (!this.locDocumento || !this.backoffice || !this.updateTrigger || !this.trigger) {
        return []
      }
      const vars = this.backoffice.documenti
      const items = []
      // item.subModel, --> usato per marchio, tipoItem tipoBene : Da categorie leggo codice, descrizione ma devo salvare solo descrizione o solo codice
      for (const item of vars) {
        items.push({value: dot.pick(item.valueField, this.locDocumento), ...item})
      }
      return items.filter(x => x.value !== undefined)
    } */
  },
  methods: {
    euro(value) {
      return this.$options.filters.euro(value)
    },
    async componentValueChange(data) {
      const { model, subModel, value, decimals } = data
      let tgt = {}
      if (subModel) {
        let vv = value[subModel]
        if (decimals >= 0) {s
          vv = +parseFloat(vv).toFixed(decimals)
        }
        dot.str(model, vv, tgt)
      } else {
        let vv = value
        if (decimals >= 0) {
          vv = +parseFloat(vv).toFixed(decimals)
        }
        dot.str(model, vv, tgt)
      }
      _.merge(this.locDocumento, tgt)
      await this.aggiornaCorrelati(data)
      this.$store.commit('documenti/SET_DOCUMENTO', this.locDocumento) // verificare se va fatta store_temp
    },
    async aggiornaCorrelati(data) {
      this.locDocumento.appoggio = this.locDocumento.appoggio || {}
      switch (data.model) {
         case 'tipoDocumento.codice':
          this.locDocumento.appoggio.tipoDocumento = data.value
          this.locDocumento.appoggio.clienteVisibile = data.value.visualizzaCliente
          this.locDocumento.appoggio.fornitoreVisibile = data.value.visualizzaFornitore
          this.locDocumento.appoggio.spedizioneVisibile = data.value.infoSpedizione
          this.locDocumento.appoggio.pagamentoVisibile = data.value.infoPagamento
          this.locDocumento.tipoDocumento = data.value
          // this.locDocumento.tipoDocumentoDescrizione = data.value.descrizione
          this.updateTrigger++
          break;
        case 'anagrafica.cliente':
        case 'anagrafica.fornitore':
          const clienteId = data.value.codice
          const clifor = await clienti.getCliente(clienteId)
          // this.locDocumento.appoggio.clifor = clifor
           _.set(this.locDocumento,'appoggio.clifor', clifor)
          _.set(this.locDocumento, 'pagamento.condizioni', _.get(clifor, 'amministrativi.pagamento.condizioni', ''))
           _.set(this.locDocumento, 'pagamento.dettaglio.modalita', _.get(clifor, 'amministrativi.pagamento.dettaglio.modalita', ''))
           const sede = clifor.recapiti.length > 0 ? clifor.recapiti.find(x => x.tipo.codice === 'principale') : {}
           _.set(this.locDocumento, 'spedizione.destinazione', sede)
           _.set(this.locDocumento, data.model + '.amministrativi', _.get(clifor, 'amministrativi', ''))
           _.set(this.locDocumento, data.model + '.fatturazione', _.get(clifor, 'fatturazione', ''))
           await this.$nextTick()
          this.updateTrigger++
          break;
        case 'spedizione.destinazione':
          _.set(this.locDocumento, 'spedizione.destinazione', data.value)
          break;
        default:
          break
      } 
    }
  }
}

</script>
